<template>
  <div class="personal-counter__wrapper">
    <div class="personal-counter__content">
      <EPersonalCounterIndicator
        v-if="showIndicator"
        :type="indicatorType"
        data-test-id="personal-counter-indicator"
      />
      <EIcon
        icon="tree-color"
        data-test-id="personal-counter-tree"
      />
      <span
        class="personal-counter__text"
        data-test-id="personal-counter-text"
      >
        {{ trees }}
      </span>
    </div>
    <component
      :is="progressComponent"
      v-if="showProgress"
      :percentage="nextTree"
      :class="`personal-counter__progress--${isDesktopUp ? 'linear' : 'circle' }`"
      data-test-id="personal-counter-progress"
    />
    <EIcon
      v-if="checkpoint"
      :icon="checkpointIcon"
      size="s"
      class="personal-counter__checkpoint"
      data-test-id="personal-counter-checkpoint"
    />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import screen from '~~/common/vue/mixins/screen';
import EIcon from '~~/common/vue/components/icon';
import EPersonalCounterProgressCircle from './progress-circle';
import EPersonalCounterProgressLinear from './progress-linear';
import EPersonalCounterIndicator from './indicator';

export default {
  name: 'EPersonalCounterButtonContent',
  components: {
    EIcon,
    EPersonalCounterIndicator,
    EPersonalCounterProgressCircle,
    EPersonalCounterProgressLinear,
  },
  mixins: [
    screen(),
  ],
  props: {
    checkpoint: {
      type: String,
      default: null,
    },
    checkpointIcon: {
      type: String,
      default: 'leaf',
    },
    shouldIncrement: {
      type: Boolean,
      default: false,
    },
    showIndicator: {
      type: Boolean,
      required: true,
    },
    trees: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('global', ['locale']),
    ...mapState('user', [
      'lastTree',
      'loggedIn',
      'treeCount',
    ]),
    ...mapGetters('user', [
      'nextTree',
    ]),
    indicatorType() {
      return this.isDesktopUp ? 'badge' : 'icon';
    },
    progressComponent() {
      return this.isDesktopUp ? 'EPersonalCounterProgressLinear' : 'EPersonalCounterProgressCircle';
    },
    showProgress() {
      return !(this.showIndicator && this.isDesktopUp);
    },
  },
};
</script>

<style lang="scss" scoped>
$checkpoint-size: $icon-size-s;

.personal-counter__wrapper {
  display: flex;
  flex-direction: column;
  gap: $space-2s;
}

.personal-counter__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 0 $space-1s;
  margin-top: $space-1s - $space-3s;

  @include desktop {
    flex-direction: row;
    margin-top: 0;
  }
}

.personal-counter__text {
  color: var(--color-text-primary);
  display: contents;
  font-size: $font-s;

  @include desktop {
    font-size: $font-m;
  }
}

.personal-counter__checkpoint {
  animation: e-checkpoint $timing-1l ease-in-out $timing-m 1;
  height: $checkpoint-size;
  width: $checkpoint-size;
  position: absolute;
  bottom: $space-2l;
  left: $space-2l;
  opacity: 0;
  transform: translateY($checkpoint-size);

  @include desktop {
    bottom: -$space-2s;
    left: calc(50% - #{$checkpoint-size} / 2);
  }
}

.personal-counter__progress--circle {
  position: absolute;
  top: $space-3s;
  left: $space-3s;
}

.personal-counter__progress--linear {
  transform: translateY($space-3s);
}
</style>
